module.exports = __webpack_public_path__ + "img/noplan.1ca4ce16.png";